/* eslint-disable no-console */

import React from 'react';
import styled from 'styled-components/macro';
import { Layout } from 'components/organisms';
import { MediaUpdateForm } from 'containers';
import { Title } from 'components/atoms';
import { useRouterContext } from 'hooks';

const ThePage = () => {
  const handleOnSubmitImage = (values) => {
    console.log('onSubmit', values)
  }

  const { match: { params: { assetId } } } = useRouterContext()

  return (
    <Layout>
      <Page>
        <Page.Header>
          <Title>Editar imagem</Title>
        </Page.Header>
        <MediaUpdateForm
          imageId={assetId}
          onSubmit={handleOnSubmitImage}
          lang="pt"
          isActive
        />
      </Page>
    </Layout>
  );
}

const Page = styled.div``;

Page.Header = styled.div`
  margin-bottom: ${props => props.theme.spacing.l};
`;

export default ThePage;
